import styled from 'shared/theme'

export const ErrorText = styled.span`
    display: block;
    color: ${props => props.theme.colors.danger};
    margin-top: 0.75rem;
    font-size: 0.75rem;
    line-height: 0.75rem;
`
